import { DateTime, Info } from "luxon";
import { DropdownMenu, DropdownMenuContent, DropdownMenuLabel, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger } from "../DropdownMenu/DropdownMenu";
import { Button } from "../Button";
import { TbArrowLeftCircle, TbArrowRightCircle } from "react-icons/tb";
import { useState } from "react";

interface MonthPickerProps {
    selected: {from: DateTime, to: DateTime};
    onSelect: (value: {from: DateTime, to: DateTime}) => void;
    disabled?: {before: DateTime, after: DateTime};
    algin: "start" | "end" | "center";
    variant?: "outline" | "ghost" | "link";
    classname?: string;
}

export function MonthPicker({selected, disabled, onSelect, algin = "center", variant = "outline", classname = "min-w-[200px] max-w-[200px] capitalize"}:MonthPickerProps) {
  const [year, setYear] = useState<number>(DateTime.local().year)
  let monthIdx = selected.from.month - 1

  function handleChangeMonth(monthIdx: string) {
    let from = DateTime.local().set({year: year, month: Number(monthIdx) + 1}).startOf('month')
    let to = DateTime.local().set({year: year, month: Number(monthIdx) + 1}).endOf('month')
    onSelect({from: from, to: to})
  }

  function nextYear() {
    setYear(year + 1)
  }

  function prevYear() {
    setYear(year - 1)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={"datepicker"} className={classname}>{Info.months()[monthIdx]} {year}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={algin} className="min-w-[200px]">
        <div className="flex text-sm justify-between items-center">
          {year === DateTime.local().year - 5 ? <TbArrowLeftCircle className="h-6 w-6 p-1 bg-border"/> : <TbArrowLeftCircle  className="h-6 w-6 p-1 bg-border" onClick={() => prevYear()}/> }
          <div className="font-semibold">{year}</div>
          {DateTime.local().year === year ? <TbArrowRightCircle className="h-6 w-6 p-1 bg-border"/> : <TbArrowRightCircle className="h-6 w-6 p-1 bg-border" onClick={() => nextYear()}/> }
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={String(monthIdx)} onValueChange={(value) => handleChangeMonth(value)}>
          {Info.months().map((month, idx) => (
            <DropdownMenuRadioItem key={idx} value={String(idx)} disabled={year >= DateTime.local().year && idx + 1 > DateTime.local().month} className="text-center capitalize">{month}</DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}